{
    "raportakimhedef": {
        "Baslik": "Takım Karşılaştırma",
        "Takim": "Takım",
        "Yil": "Yıl",
        "Ay": "Ay",
        "Satislar": "Satışlar",
        "Hedefler": "Hedefler",
        "Urun": "Ürün",
        "Musteri": "Müşteri",
        "Tutar": "Tutar",
        "Kullanici": "Kullanıcı",
        "HedefTutar": "Hedef Tutar",
        "OnayliAdet": "Onaylı Adet",
        "OnayliTutar": "Onaylı Tutar",
        "Ara": "Sorgula",
        "Temizle": "Temizle"
    }
}
